import { FC } from 'react';
import Modal from 'react-modal';
import styles from './SerialInfoModal.module.scss';

type Props = {
  serialNumber: string;
  courseName: string;
  isOpen: boolean;
  onClickCloseButton: () => void;
  onClickCopy: () => void;
};

const SerialInfoModal: FC<Props> = ({
  serialNumber,
  courseName,
  isOpen = false,
  onClickCloseButton,
  onClickCopy,
}) => (
  <>
    <Modal
      className={styles['serial-info-dialog']}
      overlayClassName={styles.overlay}
      isOpen={isOpen}
    >
      <div className={styles['serial-info-dialog-container']}>
        <div
          className={`${styles['serial-info-dialog-header']} ${styles['mod-close-btn']}`}
        >
          <div className={styles['serial-info-dialog-header-left']}>
            <p>Super ELMer</p>
          </div>
          <div className={styles['serial-info-dialog-header-right']}>
            <button
              type="button"
              className={styles['close-button']}
              onClick={onClickCloseButton}
            >
              <figure>
                <div
                  className={`${styles['svg-icon']} ${styles['ic-close']}`}
                />
              </figure>
            </button>
          </div>
        </div>

        <div className={styles['serial-info-dialog-content']}>
          <div>
            <p>
              <span className={styles['about-label']}>Course:</span>
              <span className={styles['about-information-text']}>
                {courseName}
              </span>
            </p>
          </div>
          <div>
            <p>
              <span className={styles['about-label']}>Serial:</span>
              <span className={styles['about-information-text']}>
                {serialNumber}
              </span>
            </p>
          </div>
        </div>

        <div
          className={`${styles['serial-info-dialog-footer']} ${styles['mod-center']}`}
        >
          <button
            type="button"
            className={`${styles['copy-button']} ${styles['mod-bordered']}`}
            onClick={onClickCopy}
          >
            Copy serial code
          </button>
        </div>
      </div>
    </Modal>
  </>
);
export default SerialInfoModal;
